module.exports = __webpack_public_path__ + "static/christmas_candle_blow_1963_2.2902b571.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project3/christmas_candle_blow_1963_2.jpg
// module id = 503
// module chunks = 142966368958528